// extracted by mini-css-extract-plugin
module.exports = {"car_city":"car_city-CNzfwkjL"};